<template>
  <div>
    <template>
      <ValidationObserver
        ref="observer"
        v-slot="{ valid, dirty }"
      >
        <NavTabs
          massBalanceCustomStyle="massBalanceStyle"
          :tabs="tabs"
          :activeTab="newActiveTab"
          @sendData="updateData"
          @inputChange="(data) => $emit('inputChange', data)"
          @changeIndicatorType="changeIndicatorType"
        />

        <SlotScopeWatcher
          :value="dirty"
          @change="$emit('dirtyChanged', dirty)"
        />
        <SlotScopeWatcher
          :value="valid"
          @change="$emit('validChanged', valid)"
        />
      </ValidationObserver>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NavTabs from '@/components/shared/widgets/Nav-tabs.vue';
import { ValidationObserver } from 'vee-validate';
import Vue from 'vue';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher.vue';
import FlowmetersForm from '@/views/sites/massBalance/formDetails/FlowmetersForm.vue';
import SimplifiedFlowMeterForm from '@/views/sites/massBalance/simplified/FlowMetersForm.vue';
import ProductsForm from '@/views/sites/massBalance/formDetails/ProductsForm.vue';
import AnalysisForm from '@/views/sites/massBalance/formDetails/AnalysisForm.vue';
import SummaryForm from '@/views/sites/massBalance/formDetails/SummaryForm.vue';
import MassBalanceStepForm from '@/views/sites/massBalance/formDetails/MassBalanceStepForm.vue';
import { SIMPLIFIED } from '@/aquassist-shared/constants/massBalance';
import { isEmpty } from 'lodash';

export default {
    name: 'MassBalanceForm',
    components: {
        NavTabs,
        SlotScopeWatcher,
        ValidationObserver,
    },
    props: {
        sample: {
            type: Object,
            default: () => ({}),
        },
        massBalanceSelected: {
            type: Object,
            default: () => ({}),
        },
        selection: {
            type: Array,
            default: () => {},
        },
        analysisSelection: {
            type: Array,
            default: () => {},
        },
        massBalanceType: {
            type: String,
            default: '',
        },
        isDisableModalHeader: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            components: [],
            tabs: [],
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
        ]),
        newActiveTab: {
            get() {
                return this.activeTab;
            },
            set(newValue) {
                this.$store.dispatch('changeActiveTab', newValue);
            },
        },
    },

    async created() {
        this.$store.dispatch('changeActiveTab', 0);
        this.components = this.componentsArray();
        this.tabs = this.tableHeaders();
    },
    methods: {
        componentsArray() {
            let componentsArr = [];
            if (this.massBalanceType === SIMPLIFIED) {
                componentsArr = [MassBalanceStepForm, SimplifiedFlowMeterForm, ProductsForm, SummaryForm];
                if (!isEmpty(this?.massBalanceSelected) && this?.massBalanceSelected?.indicatorType !== 'ppm') {
                    componentsArr.splice(2, 1);
                }
            } else componentsArr = [MassBalanceStepForm, FlowmetersForm, AnalysisForm, ProductsForm, SummaryForm];
            return componentsArr;
        },

        tableHeaders(removeProductsForm = false) {
            const headerTitle = ['massBalance', 'flowmeter', 'analysis', 'products', 'summary'];
            if (this.massBalanceType === SIMPLIFIED) {
                headerTitle.splice(2, 1);
            }
            // for simplified massBalance and indicator type is not ppm we remove products form
            if (removeProductsForm || (this.massBalanceType === SIMPLIFIED
            && (!isEmpty(this?.massBalanceSelected) && this?.massBalanceSelected?.indicatorType !== 'ppm'))) {
                headerTitle.splice(2, 1);
            }
            const headers = this.components.map((component, index) => ({
                index,
                props: {
                    mutableValue: this.sample,
                    selection: this.selection,
                    analysisSelection: this.analysisSelection,
                    massBalanceType: this.massBalanceType,
                    massBalanceSelected: this.massBalanceSelected,
                },
                name: this.$t(`massBalance.modalStep.${headerTitle[index]}`),
                component: Vue.component(`tab-${index}`, component),
                disabled: this.isDisableModalHeader,
            }));
            this.$store.dispatch('setTabs', headers);
            return headers;
        },
        updateData(data) {
            this.$emit('sendData', data);
        },
        changeIndicatorType(indicatorType) {
            if (indicatorType !== 'ppm') {
                this.components = this.components.filter(
                    comp => (comp.name ? comp.name !== 'ProductsForm' : comp !== ProductsForm),
                );
                this.tabs = this.tableHeaders(true);
            } else {
                this.components = this.componentsArray();
                this.tabs = this.tableHeaders();
            }
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/styles/massBalanceStyle.scss";
</style>
